<template>
  <div class="category-chooser-container">
    <h1>Nach welcher Kategorie willst du bewerten?</h1>
    <div class="buttons-container">
      <button 
        v-for="(cat, index) in topThreeCategories" 
        :key="index" 
        @click="selectCategory(cat)"
        class="category-button"
      >
        <h2>{{ cat.start_word }} vs {{ cat.end_word }}</h2>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "CategoryChooser",
  data() {
    return {
      categories: [],
    };
  },
  computed: {
    topThreeCategories() {
      return this.categories.slice(0, 3);
    },
  },
  mounted() {
    this.fetchCategories();
  },
  methods: {
    fetchCategories() {
      fetch("https://laubloch.de/backend/categories.php")
        .then((res) => res.json())
        .then((data) => {
          if (data.status === "success") {
            this.categories = data.data;
          } else {
            console.error("Error fetching categories:", data.message);
          }
        })
        .catch((err) => console.error("Fetch error:", err));
    },
    selectCategory(category) {
      // Rückkehr zur Formenbewerter-Seite inkl. Übergabe der ausgewählten Kategorie
      this.$router.push({
        name: "FormenBewerter",
        query: { selectedCategory: JSON.stringify(category) },
      });
    },
  },
};
</script>

<style scoped>
.category-chooser-container {
  padding: 20px;
  align-items: center;
  padding-top: 10%;
 
}

.buttons-container {
  display: flex;
  flex-direction: column;
  margin-top: 15vh;
  align-items: center;


 
}

.category-button {
  width: min(450px, 75vw);
  
  padding: 10px 15px;
  margin: 5px 0;
  font-size: 16px;
  cursor: pointer;
  border: 1px solid black;
  transition: background-color 0.2s ease;
  text-align: center;
}

.category-button:hover {
  background-color: #e0e0e0;
}
</style>
